import { MulticastDelegate } from "./MulticastDelegate";
import { PropertyObservable } from "./PropertyObservable";
export class ObservableCollectionEntry extends PropertyObservable {
  get collection() {
    return this._collection;
  }

  get item() {
    return this._item;
  }

  get index() {
    return this._collection.entries.indexOf(this);
  }

  get previous() {
    const index = this.index;
    return index > 0 ? this._collection.entries[index - 1] : null;
  }

  get next() {
    const index = this.index;
    return index < this._collection.entries.length - 1 ? this._collection.entries[index + 1] : null;
  }

  constructor(collection, item, eventDelegate = MulticastDelegate, name) {
    super(eventDelegate, name);
    this._collection = void 0;
    this._item = void 0;
    this._collection = collection;
    this._item = item;

    this._item.propertyChanged.subscribe(this.onItemPropertyChanged, this);
  }

  onItemPropertyChanged(sender, ea) {
    this.onReferenceObserved('item', sender, ea);
  }

  toJSON(...includeProperties) {
    return super.toJSON('item', 'index', ...includeProperties);
  }

}
